import type { ReactNode } from 'react'

interface PageHeaderTitle {
  eyebrow?: string
  h1: string
}

interface PageHeaderProps {
  title: PageHeaderTitle | string
  sub?: string
  actions?: ReactNode[]
}

const PageHeader = ({ title, sub, actions }: PageHeaderProps) => {
  const eyebrow = typeof title === 'string' ? '' : title.eyebrow
  const heading = typeof title === 'string' ? title : title.h1

  return (
    <div className="ph-page-h">
      <div>
        {eyebrow && <div className="eyebrow mb-8">{eyebrow}</div>}
        <h1>{heading}</h1>
        {sub && <div className="sub mt-8">{sub}</div>}
      </div>
      {actions && actions.length > 0 && <div className="ph-row">{actions}</div>}
    </div>
  )
}

export default PageHeader
